export const GET_INVOICE_PAGE_DATA = 'GET_INVOICE_PAGE_DATA'
export const GET_INVOICE_PAGE_DATA_SUCCESS = 'GET_INVOICE_PAGE_DATA_SUCCESS'
export const GET_INVOICE_DOWNLOAD_DATA = 'GET_INVOICE_DOWNLOAD_DATA'
export const GET_INVOICE_DATA_SUCCESS = 'GET_INVOICE_DATA_SUCCESS'
export const GET_INVOICE_PAGE_DETAILS = 'GET_INVOICE_PAGE_DETAILS'